import { useCallback, useEffect, useState } from "react";
import { LoadingOverlay, Stack, Text } from "@mantine/core";
import { findBlacklist } from "../../../../../api/BlacklistAPI";
import BlacklistsContent from "./BlacklistsContent";
import { useParams } from "react-router-dom";
import BlacklistsContentAll from "./BlacklistsContentAll";
import { useLanguage } from "../../../../../stores/LanguageStore";

const RightWrapperBlacklist = () => {
  const lang = useLanguage((s) => s.language);
  const { blacklistId } = useParams();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState(null);

  const handleLoading = useCallback(() => {
    setLoading(true);
    findBlacklist(parseInt(blacklistId))
      .then((res) => {
        setList(res.data.blacklist_profile);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [blacklistId]);

  useEffect(() => {
    if (blacklistId !== "none" && blacklistId !== "all") {
      handleLoading();
    }
  }, [blacklistId]);

  if (blacklistId === "none") {
    return (
      <Stack h={"100%"} flex={1} align="center" justify="center">
        <Text>{lang.prospects.select_blacklist}</Text>
      </Stack>
    );
  }

  return (
    <Stack h={"100%"} pos={"relative"} flex={1}>
      {loading ? (
        <LoadingOverlay visible loaderProps={{ size: 48 }} />
      ) : blacklistId === "all" ? (
        <BlacklistsContentAll />
      ) : (
        <BlacklistsContent list={list} />
      )}
    </Stack>
  );
};

export default RightWrapperBlacklist;
